import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Search, X } from "react-feather"
import _ from "lodash"

import { useDebounce } from "../../../hooks/useDebounce"

import "./index.scss"

function SearchBar({
  size = "medium",
  disabled = false,
  placeholder = "Busca",
  className = "",
  onChange = () => {},
}) {
  const dispatch = useDispatch()
  const { keyword } = useSelector((state) => state.crm)
  const [search, setSearch] = useState(keyword)
  const debouncedSearch = useDebounce(search, 500)

  useEffect(() => {
    dispatch({ type: "CHANGE_KEYWORD", payload: debouncedSearch })
    onChange(debouncedSearch)
  }, [debouncedSearch, dispatch, onChange])

  function handleClickClear() {
    setSearch("")
  }

  function returnClassName() {
    let currentClassName = `search-bar search-bar--${size} `
    if (disabled) currentClassName += `search-bar--disabled `
    if (className) currentClassName += className

    return currentClassName
  }

  return (
    <div className={returnClassName()}>
      <Search className="search-bar__icon-left" />
      <input
        type="text"
        inputMode="search"
        placeholder={placeholder}
        onChange={(evt) => setSearch(evt.target.value)}
        value={search}
      />
      <X
        className={
          !_.isEmpty(search)
            ? "search-bar__icon-right search-bar__icon-right--visible"
            : "search-bar__icon-right"
        }
        onClick={handleClickClear}
      />
    </div>
  )
}

export default SearchBar
